import { render, staticRenderFns } from "./CompanyBasicTable.vue?vue&type=template&id=0206fe58"
import script from "./CompanyBasicTable.vue?vue&type=script&lang=js"
export * from "./CompanyBasicTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports